import { createSlice } from '@reduxjs/toolkit'
import { RepaymentMethods } from 'share/enums/payment'
import { Nullable } from 'share/types'

import { RootState } from '..'

type InitialState = {
  loanRepaymentMethod: RepaymentMethods
  creditSum: Nullable<string | number>
  insuranceSum: Nullable<string | number>
  utm_params?: {
    utm_medium: string | null
    utm_source: string | null
    utm_campaign: string | null
    utm_content: string | null
    utm_click_id: string | null
  }
}

const initialState: InitialState = {
  loanRepaymentMethod: RepaymentMethods.ANNUITY,
  creditSum: null,
  insuranceSum: null
}

const loanSlice = createSlice({
  name: 'loanSlice',
  initialState,
  reducers: {
    setLoanInformation: (state, { payload }: { payload: Partial<InitialState> }) => ({
      ...state,
      ...payload
    }),
    setUtmParams: (
      state,
      {
        payload
      }: {
        payload:
          | {
              utm_medium: string | null
              utm_source: string | null
              utm_campaign: string | null
              utm_content: string | null
              utm_click_id: string | null
            }
          | undefined
      }
    ) => {
      state.utm_params = payload
    }
  }
})

export const { setLoanInformation, setUtmParams } = loanSlice.actions

export const getLoanInformation = (state: RootState) => state.loan
export const getUtmParamsSelector = (state: RootState) => state.loan.utm_params

export default loanSlice.reducer
